// Inject/replace SEO meta tags + JSON-LD blocks on the document head.
// We tag everything we add with data-dynamic-seo="1" so we can clean up
// on route change without touching the static tags from index.html.

const TAG = "data-dynamic-seo";

const clearDynamic = () => {
  document
    .querySelectorAll(`[${TAG}="1"]`)
    .forEach((el) => el.parentNode && el.parentNode.removeChild(el));
};

const setMeta = (attr, key, value) => {
  if (!value) return;
  let el = document.querySelector(`meta[${attr}="${key}"][${TAG}="1"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    el.setAttribute(TAG, "1");
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const setLink = (rel, href) => {
  if (!href) return;
  // Replace the static canonical/og link if it exists from index.html
  let existing = document.querySelector(`link[rel="${rel}"]`);
  if (existing && !existing.hasAttribute(TAG)) {
    existing.setAttribute("data-original-href", existing.getAttribute("href") || "");
    existing.setAttribute(TAG, "1");
  }
  let el = document.querySelector(`link[rel="${rel}"][${TAG}="1"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    el.setAttribute(TAG, "1");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const addJsonLd = (obj) => {
  if (!obj) return;
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.setAttribute(TAG, "1");
  script.textContent = JSON.stringify(obj);
  document.head.appendChild(script);
};

export const setPageSeo = ({
  title,
  description,
  canonical,
  ogImage,
  ogType = "website",
  jsonLd = [],
}) => {
  clearDynamic();
  if (title) document.title = title;
  setMeta("name", "description", description);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:type", ogType);
  setMeta("property", "og:url", canonical);
  setMeta("property", "og:image", ogImage);
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);
  setMeta("name", "twitter:image", ogImage);
  setLink("canonical", canonical);
  jsonLd.filter(Boolean).forEach(addJsonLd);
};

export const resetPageSeo = () => clearDynamic();
